module.exports = __webpack_public_path__ + "img/gender-chart.7a6a4c7d.svg";